import * as React from 'react';
import { FormControl } from 'react-bootstrap';

import { Organization } from '../../gs-core/common';

interface OwningUnitSelectProps {
  selectedOwningUnit: Organization;
  owningUnits: Organization[];
  onChange: (owningUnit: Organization) => void;
}

export const OwningUnitSelect = ({ selectedOwningUnit, owningUnits, onChange }: OwningUnitSelectProps) => {
  const change = (event: any) => {
    const owningUnitId = parseInt(event.target.value, 10);
    const owningUnit = owningUnits.find(unit => unit.id === owningUnitId);
    if (!owningUnit) {
      throw new Error('Missing owningUnit');
    }
    onChange(owningUnit);
  };
  return (
    <FormControl componentClass="select" onChange={change} value={selectedOwningUnit.id}>
      {owningUnits.map(unit =>
        <option key={unit.id} value={unit.id}>{unit.displayName || unit.name}</option>
      )}
    </FormControl>
  );
};



// WEBPACK FOOTER //
// ./src/DocView/Section/OwningUnitSelect.tsx